import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;
  delete solicitacao.dataPagamento;
  delete solicitacao.unidade;
  delete solicitacao.departamento;
  delete solicitacao.solicitante;

  // solicitacao.valor = converterMoeda.paraDolar(solicitacao.valor);

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/solicitacaofaturamentos', { params: parametros });
  },
  adicionar: (solicitacao, arquivos) => {
    solicitacao = normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/solicitacaofaturamentos', solicitacao).then(res => res.data.id);
  },
  alterar: (solicitacao, arquivos, id) => {
    solicitacao = normalizarParaSalvar(solicitacao, id);
    solicitacao.arquivos = arquivos;

    solicitacao = converterObjetoFormData(solicitacao);
    
    return Vue.http.put(`/api/solicitacaofaturamentos/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/solicitacaofaturamentos/${id}`)
      .then(response => response.data)
      // .then(solicitacao => normalizarParaVisualizar(solicitacao));
  },
  liberar: id => {
    return Vue.http.post(`/api/solicitacaofaturamentos/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/solicitacaofaturamentos/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/solicitacaofaturamentos/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/solicitacaofaturamentos/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/solicitacaofaturamentos/${id}/downloadarquivo/${arquivo}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-faturamento/servico.js